/**
 * Instance configuration as returned by the API
 */
export type InstanceConfig = {
  isPrivateInstance: boolean;
  namespace?: string | null;
  organizationName?: string | null;
  orgCreatedLogo?: string | null;
  orgReviewedLogo?: string | null;
  noriSessionsEnabled?: boolean | null;
  sentryDsn?: string | null;
  deploymentId?: string | null;
};

/**
 * Fetch the instance configuration
 *
 * @returns Promise resolving to the instance configuration
 */
export const fetchConfig = async (): Promise<InstanceConfig> => {
  const response = await fetch('/api/config');
  if (!response.ok) {
    throw new Error('Failed to fetch config');
  }
  return response.json();
};
